import { required, validEmail, numeric, maxLength } from 'services/validators'
import { isValidPhoneNumber } from 'react-phone-number-input'
import config from 'config'

const NOS_REZO_EXTERNAL_LEAD_ID = config('NOS_REZO_EXTERNAL_LEAD_ID')

export const validateContactFormPage = values => {
  const errors = {}
  if (!required(values.name)) {
    errors.name = 'Nombre requerido'
  }
  if (!required(values.phone)) {
    errors.phone = 'Teléfono requerido'
  } else if (!isValidPhoneNumber(values.phone)) {
    errors.phone = 'Teléfono inválido'
  }
  if (!required(values.email)) {
    errors.email = 'Email requerido'
  } else if (!validEmail(values.email)) {
    errors.email = 'Email inválido'
  }
  if (!required(values.message)) {
    errors.message = 'Mensaje requerido'
  }
  return errors
}

export const validateContactForm = values => {
  const errors = {}

  if (!required(values.fullName)) {
    errors.fullName = 'Nombre requerido'
  }
  if (!required(values.telephone)) {
    errors.telephone = 'Teléfono requerido'
  } else if (!isValidPhoneNumber(values.telephone)) {
    errors.telephone = 'Teléfono inválido'
  }
  if (!required(values.email)) {
    errors.email = 'Email requerido'
  } else if (!validEmail(values.email)) {
    errors.email = 'Email inválido'
  }
  if (required(values.telephone)) {
    errors.email = ''
  }
  if (required(values.email)) {
    errors.telephone = ''
  }
  if (values.referalLeadSource?.value == NOS_REZO_EXTERNAL_LEAD_ID) {
    if (!required(values.referalLeadId)) {
      errors.referalLeadId = 'Id Recomendación requerido'
    } else if (!numeric(values.referalLeadId)) {
      errors.referalLeadId = 'Solo números'
    } else if (!maxLength(values.referalLeadId, 6)) {
      errors.referalLeadId = 'El número máximo de dígitos es 6'
    }
  }
  if (
    !required(values.profileType) ||
    (values.profileType && values.profileType.length === 0)
  ) {
    errors.profileType = 'Perfil requerido'
  }
  if (
    values.profileType &&
    values.profileType.value === 'BROKER' &&
    !required(values.typeOfBroker)
  ) {
    errors.typeOfBroker = 'Requerido'
  }

  if (
    values.contactProfileProperties &&
    values.contactProfileProperties.length
  ) {
    const contactProfilePropertiesArrayErrors = []

    values.contactProfileProperties.forEach((contact, index) => {
      const contactProfilePropertiesErros = {}

      if (contact.rentedPropertyData) {
        const rentedPropertyDataErrors = {}
        const { startDate, endDate, tenants } = contact.rentedPropertyData

        if (startDate && !endDate) {
          rentedPropertyDataErrors.endDate = 'Campo requerido'
          contactProfilePropertiesErros.rentedPropertyData = rentedPropertyDataErrors
          contactProfilePropertiesArrayErrors[
            index
          ] = contactProfilePropertiesErros
        }
        if (!startDate && endDate) {
          rentedPropertyDataErrors.startDate = 'Campo requerido'
          contactProfilePropertiesErros.rentedPropertyData = rentedPropertyDataErrors
          contactProfilePropertiesArrayErrors[
            index
          ] = contactProfilePropertiesErros
        }

        if (tenants && tenants.length) {
          contactProfilePropertiesErros.rentedPropertyData = rentedPropertyDataErrors

          const tenantsArrayErrors = []

          tenants.forEach((tenant, tenantIndex) => {
            const tenantsErrors = {}
            if (!required(tenant.fullName)) {
              tenantsErrors.fullName = 'Sin nombre'
              tenantsArrayErrors[tenantIndex] = tenantsErrors
            }
          })

          if (tenantsArrayErrors.length) {
            rentedPropertyDataErrors.tenants = tenantsArrayErrors
            contactProfilePropertiesErros.rentedPropertyData = rentedPropertyDataErrors
            contactProfilePropertiesArrayErrors[
              index
            ] = contactProfilePropertiesErros
          }
        }
      }
    })

    if (contactProfilePropertiesArrayErrors.length) {
      errors.contactProfileProperties = contactProfilePropertiesArrayErrors
    }
  }
  return errors
}
